import { render, staticRenderFns } from "./SalaryImportModal.vue?vue&type=template&id=063941b2&scoped=true"
import script from "./SalaryImportModal.vue?vue&type=script&lang=js"
export * from "./SalaryImportModal.vue?vue&type=script&lang=js"
import style0 from "./SalaryImportModal.vue?vue&type=style&index=0&id=063941b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063941b2",
  null
  
)

export default component.exports